<template>

  <div>

    <div @click="alert = false; msgAlert='';">
      <v-alert v-model="alert" dismissible outline type="warning">
        {{ msgAlert }}
      </v-alert>
    </div>

    <v-toolbar flat>
      <v-toolbar-title class="font-weight-light headline">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <!-- FORMULÁRIO -->
        <v-btn :disabled="loading" :loading="loading" @click="clearUserData" slot="activator" color="info" icon
          title="Inserir um novo registro">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>

          <v-toolbar color="white" class="elevation-0" card>


            <v-toolbar-title class="headline font-weight-light">
              {{ formTitle }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn @click="closeAndResetForm()" color="error" round icon flat>
                <v-icon color="error" large>clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-divider></v-divider>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="user.name" :rules="inputRules" label="Nome *"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="user.email" :rules="emailRules" label="E-mail *"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-if="!isEdit" v-model="user.cpf" return-masked-value :rules="inputRules" mask="###.###.###-##"
                      label="CPF *">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    Liberar Acessos
                    <v-btn title="Liberar acessos" slot="activator" color="info" icon round
                      @click="openComponentTableAccess">
                      <v-icon>lock_open</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-footer class="pa-3 mx-auto" style="width:87%" height="auto" color="info">
              <span class="white--text">
                <strong>AVISO:</strong>
                após a criação do usuário, uma chave de acesso provisória que deve ser usada no primeiro acesso será
                enviada para o e-mail
                informado.
              </span>
            </v-footer>
            <v-card-actions pa-5 class="py-2 mt-3">
              <v-btn color="success lighten-1 mx-auto" style="width:90%" :disabled="!valid" round @click="save();">
                Salvar</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <!-- TABELA DE REGISTROS -->
    <v-data-table :loading="loading" :headers="headers" :items="users" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.cpf }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">{{utilFormatter.formatDateISOToBR(props.item.createDate) }}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativa' : 'Ativa'}}</v-chip>
        </td>
        <td class="justify-center layout px-0">
          <v-btn :disabled="loading" @click="edit(props.item)" color="info" title="Editar registro" icon round flat>
            <v-icon color="info">edit</v-icon>
          </v-btn>
          <v-btn :disabled="loading" @click="openAccessDialog(props.item)" color="warning" title="Acessos" icon round
            flat>
            <v-icon color="warning">security</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="footer" v-if="records > 0">
        <td colspan="100%">
          <strong> {{ footerText }} {{ records }} </strong>
        </td>
      </template>
      <template slot="no-data" v-else>
        <strong> {{ emptyRecordsText }} </strong>
      </template>
    </v-data-table>
    <!-- DIÁLOGO DOS ACESSOS -->
    <v-layout row justify-center>

      <table-access @sendData="setAccessInUser" ref="access"></table-access>
    </v-layout>
    <!-- DIÁLOGO DE CONFIRMAÇÃO DO ATIVAR/DESATIVAR -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogRemove" max-width="500">
        <v-card>
          <v-toolbar color="white" class="elevation-3" card>
            <v-toolbar-items>
              <v-btn @click="dialogRemove = false;" color="error" round icon flat>
                <v-icon color="error" large>remove</v-icon>
              </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-title class="headline font-weight-light">
              Excluir Registro
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="font-weight-light">
            <span>Nome: {{ userRemove.name }}</span><br>
            <span>Nome: {{ userRemove.cpf }}</span><br>
            <span>E-mail: {{ userRemove.email }}</span>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success lighten-1" block round @click="remove();">
              Sim
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
  import UserService from '../service/UserService';
  import TableAccess from "../components/Login/TableAccess"
  import UtilFormatter from '../utils/UtilFormatter';

  export default {
    components: {
      TableAccess,
    },
    data: () => ({
      valid: true,
      accessList: [],
      dialogAccess: false,
      alert: false,
      loading: false,
      msgAlert: "",
      vertical: "",
      timeout: 3000,
      dialogRemove: false,
      isEdit:false,
      userRemove: {},
      title: "Listagem de Usuários",
      buttonTitle: "inserir",
      dialog: false,
      footerText: "Total de registros: ",
      emptyRecordsText: "Nenhum registro encontrado",
      records: 0,
      users: [],
      user: {
        access: []
      },
      /**********\
      ***Rules***
      \**********/
      inputRules: [
        v => !!v || 'Campo obrigatório',
      ],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'Insira um e-mail válido'
      ],
      headers: [{
          text: 'Nome',
          align: "center",
          value: 'name'
        },
        {
          text: 'CPF',
          align: "center",
          value: 'CPF'
        },
        {
          text: 'E-mail',
          align: "center",
          value: 'email'
        },
        {
          text: 'Criado em',
          align: "center",
          value: 'createdAt'
        },
        {
          text: 'Situação',
          align: "center",
          value: 'active'
        },
        {
          value: 'active'
        },
      ],
      utilFormatter: UtilFormatter

    }),

    computed: {
      formTitle() {
        return this.user._id ? 'Alterar Usuário' : 'Criar Usuário'
      }
    },

    watch: {
      dialog(val) {
        val || this.initialize();
      }
    },

    created() {
      this.initialize();
    },
  
    methods: {
      async openComponentTableAccess() {
       
        this.$refs.access.open()
        
        
      },

      calculateRecords() {
        let amount = 0;
        for (let i = 0; i < this.users.length; i++) {
          amount++;
        }
        this.records = amount;
      },

      async initialize() {
        this.loading = true;
        try {
          this.users = await UserService.getAll();
          this.user = {};
          this.dialog = false;
          this.calculateRecords();
          this.dialogRemove = false;
          this.userRemove = {};
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },

      visualClear() {
        this.dialog = false;
        this.dialogAccess = false;
        this.dialogRemove = false;
      },

      async reloadResources() {
        try {
          this.visualClear();
          await this.initialize();
        } catch (error) {
          console.log(error);
        }
      },

      edit(p) {
        this.isEdit = true;
        this.user = Object.assign({}, p);
        this.dialog = true;
        this.$refs.access.editUserAccess(this.user.access);
      },

      async openAccessDialog(item) {
        this.user = Object.assign({}, item);
        await this.openComponentTableAccess();
        this.$refs.access.editUserAccess(this.user.access);
        this.$refs.access.readMode();

      },
      async clearUserData() {
        this.$refs.form.reset()
        this.user = {}

      },

      async remove() {
        await UserService.remove(this.userRemove);
        this.initialize();
        this.msgAlert = "Excluído com sucesso";
        this.alert = true;
      },
      setAccessInUser(data) {
        this.user.access = []
        this.user.access = JSON.parse(JSON.stringify(data));
        this.$refs.access.closeDialog()
      },
      async save() {
        if (this.$refs.form.validate()) {
          if (this.user._id) {
            await UserService.update(this.user);
            this.msgAlert = "Editado com sucesso";
            this.alert = true;
            this.isEdit = false
          } else {
            await UserService.save(this.user);
            this.msgAlert = "Salvo com sucesso";
            this.alert = true;
          }
          this.initialize();
        }

      }, // save()
      closeAndResetForm() {
        this.$refs.form.reset()
        this.initialize()
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/User.vue